const ConstanstUI = {

    LINK_LIBRE_INVERSION: "https://sadminfactory.sadmin.net/autologin?YzJGa2JXbHVabWxqWVhKbmIxODVNREUwTURBMk1EbGZabUZqZEc5eWVRPT18MnwwfDB8MDE=",
    LINK_PARTICULAR: "https://sadminfactory.sadmin.net/autologin?YzJGa2JXbHVabWxqWVhKbmIxODVNREUwTURBMk1EbGZabUZqZEc5eWVRPT18MTN8MHwwfDAx",
    LINK_PRODUCTIVO: "https://sadminfactory.sadmin.net/autologin?YzJGa2JXbHVabWxqWVhKbmIxODVNREUwTURBMk1EbGZabUZqZEc5eWVRPT18MTh8MHwwfDAx",
    LINK_POLIZAS: "https://sadminfactory.sadmin.net/autologin?YzJGa2JXbHVabWxqWVhKbmIxODVNREUwTURBMk1EbGZabUZqZEc5eWVRPT18MTh8MHwwfDAx",
}
export default ConstanstUI